// export const handleLogin = () => {
//   const consumerKey = process.env.REACT_APP_CONSUMER_KEY;
//   const callbackUrl = process.env.REACT_APP_CALLBACK_URL;
//   const authUrl = `https://login.salesforce.com/services/oauth2/authorize?response_type=token&client_id=${consumerKey}&redirect_uri=${callbackUrl}&prompt=login`;

//   window.location.href = authUrl;
// };


// export const handleLogin = (redirectTo = '/') => {
//   const consumerKey = process.env.REACT_APP_CONSUMER_KEY;
//   const baseCallbackUrl = process.env.REACT_APP_CALLBACK_URL;

//   // Append the redirect parameter to the callback URL
//   const callbackUrl = `${baseCallbackUrl}?redirect=${encodeURIComponent(redirectTo)}`;

//   const authUrl = `https://login.salesforce.com/services/oauth2/authorize?response_type=token&client_id=${consumerKey}&redirect_uri=${encodeURIComponent(callbackUrl)}&prompt=login`;

//   // Redirect the user to the Salesforce login page
//   window.location.href = authUrl;
// };



export const handleLogin = (redirectTo = '/') => {
  const consumerKey = process.env.REACT_APP_CONSUMER_KEY;
  const baseCallbackUrl = process.env.REACT_APP_CALLBACK_URL;

  // Append redirect parameter as a query parameter to the callback URL
  const callbackUrl = `${baseCallbackUrl}?redirect=${encodeURIComponent(redirectTo)}`;
  // Use the state parameter to pass the redirect path
  const state = JSON.stringify({ redirect: redirectTo });
  // Construct the Salesforce auth URL with state param
  // const authUrl = `https://login.salesforce.com/services/oauth2/authorize?response_type=token&client_id=${consumerKey}&redirect_uri=${encodeURIComponent(callbackUrl)}&prompt=login`;
  const authUrl = `https://login.salesforce.com/services/oauth2/authorize?response_type=token&client_id=${consumerKey}&redirect_uri=${encodeURIComponent(baseCallbackUrl)}&state=${encodeURIComponent(state)}`;

  console.log('REACT_APP_CALLBACK_URL:', baseCallbackUrl);
  console.log('Redirect parameter passed to handleLogin:', redirectTo);
  console.log('Constructed Callback URL:', callbackUrl);
  console.log('Generated Auth URL:', authUrl);
  window.location.href = authUrl;
};




  
  export const handleLogout = () => {
    sessionStorage.removeItem('access_token');
    localStorage.removeItem('access_token')
    window.location.reload();
  };

  export const getAccessToken = () => {
    return sessionStorage.getItem('access_token');
  };
  